<template>
        <div id="contenedor-pasoUno" class="col-4 padding-div-low">
            <div class="area">
                <div id="subidordearchivos_div text-left">
                    <h5>Paso 1: Seleccione página y sección</h5>
                    <hr />
                    <div>
                        <h6 style="padding: 5px">Página</h6>
                        <C007PaginasWeb style="padding:0; margin:0;" v-on:valorParaElPadre="cambioTipoDePagina" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoPaginaPasoUno'" :parametros="{PaginaDeInicioId: null,MenuId: null,SubmenuId: null,TipoContenedorId: null,ConPaginaDeInicio: false,ConMenu: false,ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true, ConOrdenamientoAlfabetico: true}" :valorDefinido="tipoDePaginaWebId"></C007PaginasWeb>
                        <h6 v-if="obtenerCatalogoPaginasWeb.catalogoPaginaPasoUno >= 0" style="padding: 5px; margin-top: 20px;">Sección&nbsp;<i style="cursor: pointer" class="fas fa-info-circle" @click="mostrarMensajeSecciones"></i></h6>
                        <div id="pasoUno-aviso-secciones" v-if="mostarAvisoSecciones && obtenerCatalogoPaginasWeb.catalogoPaginaPasoUno >= 0">
                            <h6><i class="fas fa-info-circle"></i>&nbsp;Nota</h6>
                            <span style="text-align: justify; display:block;">{{MENSAJE_AVISO_SECCIONES}}</span>
                        </div>
                        <C008SeccionesDeLaPaginaWeb v-if="obtenerCatalogoPaginasWeb.catalogoPaginaPasoUno >= 0"  style="padding:0; margin:0;" v-on:valorParaElPadre="cambioTipoSeccion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoSeccionPasoUno'" :parametros="{PaginaWebId: tipoDePaginaWebId, TipoFormatoId: null, ConSeccionesQueMePertenecen: true, ConArbolDeSeccionesQueMePertenecen:true, ConSeccionALaQuePertenezco: false, ConPaginaWeb: false, ConOrdenamientoDeLasSecciones: true, ConCarrusel: conCarrusel, FiltrarPorUsuario:true, ConInactivos:false}" :valorDefinido="-1" :key="tipoDePaginaWebId"></C008SeccionesDeLaPaginaWeb>
                        <CSelectGenerico v-for="subseccion in subseccionesDePagianWeb" class="subscciones" v-on:valorParaElPadre="cambioTipoSubseccion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="subseccion.idDelInput" :valorDefinido="-1" :key="subseccion.key" :elementos="subseccion.subsecciones" :mansajeValorDefinidoPlural="'las secciónes'" :mansajeValorDefinidoSingular="'un tipo de sección'"></CSelectGenerico>
                    </div>
                    <div v-if="mostrarSeccionSeleccionada">
                        <hr />
                        <p>Sección seleccionada: <span class="font-weight-bold">{{navegacionSecciones[navegacionSecciones.length -1]}}</span></p>
                        <hr />
                        <div class="text-right" style="margin-top: 20px;">
                            <div>
                                <button type="button" class="btn btn-primary" @click="comenzarCrearContenido"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar Contenido</button>
                            </div> 
                        </div> 
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  import catalogos from '@/../static/js/catalogos'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
  import formatos from '@/../static/js/enumeraciones/sicpo.js'

  export default {
      data() {
          return {
            titulo: 'Alta de noticia',
            enumeraciones,
            tipoDePaginaWebId: -1,
            tipoDeSeccionPaginaWeb: -1,
            punteroDeContenidoActual: {
                paginaWebSeleccionada: '',
                rutaSecciones: '',
                seccionCrearContenidoId: -1
            },
            arbolSeccionesPaginaWeb: [],
            subseccionesDePagianWeb: [],
            contadorSubseccion: 0,
            seccionPadre: [],
            navegacionSecciones: [],
            punteroSeccionSeleccionada: '',
            mostrarSeccionSeleccionada: false,
            conCarrusel: false,
            subseccionesAgregadasTmp: 0,
            mostarAvisoSecciones: false,
            MENSAJE_AVISO_SECCIONES: 'Se le recuerda que sólo puede agregar contenido a las secciones a las que se le asignaron  permisos, si requiere un cambio de permisos por favor comuníquese a la Dirección de Informática.'
          }
      },
      components: {
         C007PaginasWeb: catalogos.SICPO.C007PaginasWeb,
         C008SeccionesDeLaPaginaWeb: catalogos.SICPO.C008SeccionesDeLaPaginaWeb,
         CSelectGenerico
      },
      methods: {
        mostrarMensajeSecciones: function() {
            if(!this.mostarAvisoSecciones){
                this.mostarAvisoSecciones = true;
            }
            else if (this.mostarAvisoSecciones) {
                this.mostarAvisoSecciones = false
            }
        },
        /**
         * Metodo encargado de obtener valores de la navegacion y del usuario entre las secciones, actualiza
         * en base de datos el valor enEdicion de la tabla seccionesDePaginaWeb indicando que la seccion se encuantra
         * en edicion.
         */
        comenzarCrearContenido: function() {
            this.punteroDeContenidoActual.rutaSecciones = this.navegacionSecciones.join('/');
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerPunteroDeContenidoActual",this.punteroDeContenidoActual);
            // definimos metodo de API
            const SERVIDOR = api.conexion;
            /* const METODO_API_AGREGAR = api.SICPO.funcion.ModificarEstatusDeSeccion; */
            const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.altadecontenido.ModificarEstatusDeSeccion;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            // craeamos la peticion con el formulario 
            let peticionAPI = {
                SeccionDeLaPaginaWebId: this.punteroDeContenidoActual.seccionCrearContenidoId,
                EnEdicion: true,
                EsPrueba: false
            }
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } else {
                            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",true);
                            $("#contenedor-pasoUno").addClass("desabilitar-div-pasoUno");
                        }
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            );
        },
        /**
         * Metodo encargado de obtener el valor del item seleccionado en el catalogo 007PaginasWeb emitido por el componente
         * hijo que corresponde al catalogo y posteriormente construir el objeto de los campos que requerira el contenido.  
         * @see {@link identificarTipoDeFormulario}
         * @param {object} evento [evento emitido por el catalogo]
         */
        cambioTipoDePagina: function (evento) {
            this.punteroDeContenidoActual.paginaWebSeleccionada = evento.target.options[evento.target.selectedIndex].text;
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormulario",true);
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput",true);
            this.asignarCarrusel(parseInt(this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno));
            this.tipoDePaginaWebId = parseInt(this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno);
            this.tipoDeSeccionPaginaWeb  = parseInt(this.$store.getters.Get_SICPO_Catalogos_008SeccionesDeLaPaginaWeb.catalogoSeccionPasoUno);
            let tipoFormulario = this.identificarTipoDeFormulario(this.tipoDePaginaWebId,false);
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",false);
            this.$emit('mostrarTooltip','Necesitas al menos guardar un contenido para que este habilitado');
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCamposRequeridosFormulario",tipoFormulario);
            this.limpiarSubseccciones();
        },
         /**
         * Metodo encargado de asignar si la pagina o seccion tiene un carrusel.
         * @param {Number} idAComparar [id de pagina o seccion que contienen carrusel]
         */
        asignarCarrusel: function(idAComparar) {
            // agregar id de secciones o paginas que tengan carrrusel 12(presidentes).
            if(idAComparar == 12) {
                this.conCarrusel = true;
            }
            else {
                this.conCarrusel = false;
            }
        },
         /**
         * Metodo encargado de obtener el valor del item seleccionado de la seccion raiz correspondiente al catalogo 008SeccionesDeLaPaginaWeb
         * obteniendo tambien lista con el arbol jerarquico de subsecciones. 
         * @param {object} evento [evento emitido por el catalogo]
         * @param {array} arbolSeccionesPw [arbol de secciones]
         */
        cambioTipoSeccion: function (evento,arbolSeccionesPw) {
            this.limpiarSubseccciones(); 
            this.arbolSeccionesPaginaWeb = arbolSeccionesPw;
            this.tipoDeSeccionPaginaWeb = parseInt(this.$store.getters.Get_SICPO_Catalogos_008SeccionesDeLaPaginaWeb.catalogoSeccionPasoUno);
            if(this.tipoDeSeccionPaginaWeb >= 0){ 
                this.seccionPadre = arbolSeccionesPw;
                this.contadorSubseccion = evento.target.value;
                this.validarSeccionesNoValidas(evento.target.value,this.seccionPadre);
                /* this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",true); */
                this.agregarSubseccion(evento.target.value,this.seccionPadre);
                // se llenan los valores para el puntero de secciones
                this.punteroDeContenidoActual.seccionCrearContenidoId =  evento.target.value;
                let tituloSeccion = evento.target.options[evento.target.selectedIndex].text;
                this.navegacionSecciones.push(tituloSeccion);
                
                this.tipoDePaginaWebId = parseInt(this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno);
                // de momento solo en pagina pension alimenticia(id=17),constituciones(id=23),Consejeros de la Judicatura Estatal(id=2) las secciones tienen contenidos distintos
                let tipoFormulario = (this.tipoDePaginaWebId == 17 || this.tipoDePaginaWebId == 23 || this.tipoDePaginaWebId == 2) ? this.identificarTipoDeFormulario(this.tipoDeSeccionPaginaWeb,true) : this.identificarTipoDeFormulario(this.tipoDePaginaWebId,false);
                this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCamposRequeridosFormulario",tipoFormulario);
            }
            else {
                this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",false);
                this.$emit('mostrarTooltip','Necesitas al menos guardar un contenido para que este habilitado');
            }
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
        },
        /**
         * Metodo encargado de manejar el evento onChange de todos los componentes relacionados a subsecciones ademas
         * de construir de manera dinamica las secciones hijas correspondientes. 
         * @param {object} evento [evento emitido por el catalogo subseccion]
         */
        cambioTipoSubseccion: function(evento) {
            let idSubseccionEnEvento = evento.target.getAttribute('id');
            let agregarSeccionNavegacion = false;
            let eliminoSeccionDeNavegacion = false;
            let numeroDeSubsecciones = this.subseccionesDePagianWeb.length;
            let indexSubseccion = this.subseccionesDePagianWeb.findIndex(
                subseccion =>  subseccion.idDelInput == idSubseccionEnEvento
            );
            let indexSeccion = (indexSubseccion + 1);
            // se suma 1 a indexSubseccion para que tome el valor de los elementos ya que los arrays inician en 0
            let eliminarDesde = (indexSubseccion + 1);
            let numeroSubseccionesEliminar = (numeroDeSubsecciones - eliminarDesde);
            let tituloSeccion = evento.target.options[evento.target.selectedIndex].text;
            if(numeroSubseccionesEliminar > 0){
                for(let i=0;i<numeroSubseccionesEliminar;i++){
                    this.subseccionesDePagianWeb.pop();
                }
                // se le suma uno para eliminar hasta el index actual del array
                indexSeccion = (indexSubseccion + 1);
                let numeroNavegacionSubsecciones = this.navegacionSecciones.length;
                let seccionesEliminarNavegacion = numeroNavegacionSubsecciones - indexSeccion;
                for(let s=0;s<seccionesEliminarNavegacion;s++){
                    this.navegacionSecciones.pop();
                    eliminoSeccionDeNavegacion = true;
                }
            }

            agregarSeccionNavegacion = (numeroDeSubsecciones == this.subseccionesAgregadasTmp) ? true : false;
            this.subseccionesAgregadasTmp = numeroDeSubsecciones;

            this.contadorSubseccion = evento.target.value;
             this.validarSeccionesNoValidas(evento.target.value,this.subseccionesDePagianWeb[indexSubseccion].seccionPadre);
            this.agregarSubseccion(evento.target.value,this.subseccionesDePagianWeb[indexSubseccion].seccionPadre);
            this.punteroDeContenidoActual.seccionCrearContenidoId =  evento.target.value;
            if(evento.target.value >= 0) {
                if(!eliminoSeccionDeNavegacion && agregarSeccionNavegacion && (indexSeccion == numeroDeSubsecciones && (this.navegacionSecciones.length >= (numeroDeSubsecciones+1)))) {
                    this.navegacionSecciones.pop();
                }
                this.navegacionSecciones.push(tituloSeccion);
            }
            else {
                if(!eliminoSeccionDeNavegacion && !agregarSeccionNavegacion){
                    this.navegacionSecciones.pop();
                }
            }
            // restablecer campos requeridos para el formulario
            let tipoFormulario = this.identificarTipoDeFormulario(evento.target.value,true);
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCamposRequeridosFormulario",tipoFormulario);
        },
        /**
         * Metodo encargado de validar que el item seleccionado de una seccion sea de un valor 
         * que se encuentra en el arbol de secciones omitiendo asi valores default (en este caso -1).
         * @param {Number} idSeccion [valor que reprenta la llave de la seccion seleccionada]
         */
        validarSeccionesNoValidas: function(idSeccion,seccionPadre) {
            const valorNoPermitido = -1;
            let indexSeccion = -1;
            let permiteSubirContenido = false;
          
            if(seccionPadre != null && seccionPadre.length > 0 && idSeccion != valorNoPermitido) {
                indexSeccion = seccionPadre.findIndex(s => s.SeccionDeLaPaginaWebId == idSeccion);
                permiteSubirContenido = (seccionPadre[indexSeccion].PermiteSubirContenido) ? true: false;
            }

            this.mostrarSeccionSeleccionada = true;
            if(idSeccion == valorNoPermitido || !permiteSubirContenido) {
                this.mostrarSeccionSeleccionada = false;
            }
        },
        /**
         * Metodo encargado de limpiar todos las subsecciones y la variables relacionadas con la logica 
         * de estas. 
         */
        limpiarSubseccciones: function() {
            this.subseccionesDePagianWeb = [];
            this.contadorSubseccion = 0;
            this.seccionPadre = [];
            this.navegacionSecciones = [];
            this.subseccionesAgregadasTmp = 0;
            this.mostrarSeccionSeleccionada = false;
        },
        /**
         * Metodo encargado de crear una subseccion y agregarla a la vista para que posteriormente pueda
         * ser construido de manera dinamica en la vista correspondiente al componente pasoUno. 
         * @param {Number} idSeccion [valor que reprenta la llave de la seccion seleccionada]
         * @param {Object} seccionPadre [seccion padre de la subseccion seleccionada]
         */
        agregarSubseccion: function(idSeccion,seccionPadre) {
            // se valida que no cree subsecciones si su valor es el valor predefinido (no valido)
            if(idSeccion != -1) {
                let subsecciones = seccionPadre.find(subseccion => subseccion.SeccionDeLaPaginaWebId == idSeccion).SeccionesQueMePertenecen;
                if(subsecciones != null && subsecciones != undefined && subsecciones.length > 0) {
                    this.seccionPadre = subsecciones;
                    let objetoSubseccion = this.construirObjetoSubseccion(subsecciones);
                    this.subseccionesDePagianWeb.push(objetoSubseccion);
                }
            }
        },
        /**
         * Metodo encargado de transformar los valores obtenidos en el arbol de subsecciones a la estructura 
         * requerida para su construccion dinamica.
         * @param {Array} listaSubsecciones [lista de subsecciones]
         * @returns {Object} objetoSubseccion [objeto contruido con la estructura de una subseccion]
         */
        construirObjetoSubseccion: function(listaSubsecciones) {
            let objetoSubseccion = {};
            let identificadorInput = 'subseccion';
            let idInputSubseccion = identificadorInput + this.contadorSubseccion;
            let keyInputSubseccion = identificadorInput + this.contadorSubseccion;
            objetoSubseccion.idDelInput = idInputSubseccion;
            objetoSubseccion.key = keyInputSubseccion;
            objetoSubseccion.subsecciones = [];
            objetoSubseccion.seccionPadre = this.seccionPadre;
            listaSubsecciones.forEach(subseccion => {
                let valoresSubseccion = {
                    valor: subseccion.SeccionDeLaPaginaWebId,
                    nombre: subseccion.NombreDeLaSeccion
                };
                objetoSubseccion.subsecciones.push(valoresSubseccion);
            });
            this.contadorSubseccion ++;
            return objetoSubseccion;
        },
         /**
         * Metodo encargado de identificar el tipo de formulario para posteriormente detectar los
         * capos que campos que requiere para ese contenido.
         * @see {@link identificarCamposParaFormulario}
         * @param {Number} id [valor correspondiente a la pagina web seleccionada]
         * @param {Number} identificarPorSeccion [valor correspondiente a la seccion seleccionada]
         * @returns {Object} camposDeFormulario [objeto con los campos requeridos para ese tipo de contenido]
         */
        identificarTipoDeFormulario: function(id,identificarPorSeccion) {
            let camposDeFormulario = this.identificarCamposParaFormulario(id,identificarPorSeccion);
            //console.log("CFormularioPasoUno identificarTipoDeFormulario camposDeFormulario: ", camposDeFormulario);
            return camposDeFormulario;
        },
        /**
         * Metodo encargado de agregar los input actuales del formulario para posteriormente identificar caules 
         * son requeridos.
         * @see {@link asignarPrioridadACamposDeFormulario}
         * @param {Number} id [valor correspondiente a la pagina web seleccionada]
         * @param {Number} identificarPorSeccion [valor correspondiente a la seccion seleccionada]
         * @returns {Object} camposNecesariosFormulario [objeto con los campos requeridos para ese tipo de contenido]
         */
        identificarCamposParaFormulario: function(id,identificarPorSeccion) {
            let camposDeFormulario = ['textoDelContenido','textoDelVinculo','archivosDeContenido','vinculo','titulo','imagenDeContenido', 'opcionesComunicadoUrgente', 'fechaDePublicacion','listaDeArchivos','rangoPresidente','nombrePresidente','archivoConVinculo','disposicionEspecial','catalogoPoderes','imagenesObligaciones'];
            let camposNecesariosFormulario = {};
            camposNecesariosFormulario['tipoDeFormulario'] = this.paginaRequiereComunicado(id)? 'comunicado': 'comun';
            for(let i=0;i<camposDeFormulario.length; i++) {
                let llave = camposDeFormulario[i];
                let valoresDeCampo = this.asignarPrioridadACamposDeFormulario(id,llave,identificarPorSeccion);
                //console.log("CFormularioPasoUno identificarCamposParaFormulario llave/key: ",llave);
                //console.log("CFormularioPasoUno identificarCamposParaFormulario valoresDeCampo: ",valoresDeCampo);
                camposNecesariosFormulario[llave] = valoresDeCampo;
            }
            //console.log("CFormularioPasoUno identificarCamposParaFormulario camposNecesariosFormulario: ",camposNecesariosFormulario);
            return camposNecesariosFormulario;
        },
        /**
         * Metodo encargado de asignar los campos requeridos segun el id de la pagina o subseccion mediante un catalogo switch
         * que contiene las combinaciones posibles hasta el momento.
         * @see {@link asignarPrioridadACamposDeFormulario}
         * @param {Number} id [valor correspondiente a la pagina web seleccionada]
         * @param {String} campoDeFormulario [input del formulario a evaluar]
         * @param {Number} identificarPorSeccion [valor correspondiente a la seccion seleccionada]
         * @returns {Object} reglasDeCampo [objeto que indica si el campo es opcional o requerido]
         */
        asignarPrioridadACamposDeFormulario: function(id,campoDeFormulario,identificarPorSeccion) {
            let reglasDeCampo = {
                opcional: false,
                requerido: false
            };
            let idPaginasWeb      = [];
            let idSecciones       = [];
            let arregloIdComparar = [];
            switch(campoDeFormulario) {
                case 'textoDelContenido':
                    idPaginasWeb   = [12,5,7,8,9,10,16,18,22,23,24,25,26,27,28,34,35,45,54,4,62,63];
                    idSecciones    = [3,29,45,154,155,156,157,120,121,124,125,128,129,133,134,136,138,140,142,143,144,146,147,179,219,249,255,271,272,273,274,275,276,277,278,279,280,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,316,317,318,319,320,2334];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    // comparacion con negacion, incluir en arreglos de paginasWeb y secciones el id de los elementos que no cargaran el campo textoDelContenido
                    if(!this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'textoDelVinculo':
                    idPaginasWeb = [1,4,5,6,9,19,20,21,38,39,43,44,49,52,53,54,41,57,62,63,1067];
                    idSecciones = [249],219,255,316,317,318,319,320;
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'archivosDeContenido':
                    idPaginasWeb = [1,3,4,5,7,8,9,10,17,19,20,21,22,23,24,25,26,27,29,14,28,34,35,38,39,41,43,44,45,46,49,52,53,54,57,61,62,63,64,65,66,68,1067,2072];
                    idSecciones = [29,45,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,66,67,68,69,70,71,72,73,74,75,76,77,78,154,155,156,157,167,168,169,170,171,172,173,174,179,204,205,206,207,249,219,255,305,316,317,324,325,344];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'vinculo':
                    idPaginasWeb = [5,9,54,62,63];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'titulo':
                    idPaginasWeb = [19,21,41,20,1067];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'imagenDeContenido':
                    idPaginasWeb = [12,19,21,41,20];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'opcionesComunicadoUrgente':
                    idPaginasWeb = [19];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'fechaDePublicacion':
                    idPaginasWeb = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,34,35,38,41,43,44,45,46,52,54,57,59,61,62,63,64,65,66,68,1067,2067,2072];
                    idSecciones = [3,28,45,29,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,66,67,68,69,70,71,72,73,74,75,76,77,78,148,154,155,156,157,167,168,169,170,171,172,173,174,179,204,205,206,207,271,272,273,274,275,276,277,278,279,280,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305,316,317,318,319,320,324,325,344,2334];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'fechaDePublicacionFinal':
                    idPaginasWeb = [19];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'listaDeArchivos':
                    idPaginasWeb = [];
                    idSecciones = [83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,117,118,119,122,123,126,127,130,131,132,135,137,139,141,145,66,67,68,69,70,71,72,73,74,75,76,77,78,167,168,169,170,171,172,173,174,168,170,172,174,204,205,206,207];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'rangoPresidente':
                    idPaginasWeb = [12];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'nombrePresidente':
                    idPaginasWeb = [4,6,12];
                    idSecciones = [3];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'disposicionEspecial':
                    idPaginasWeb = [19,28];
                    idSecciones = [179];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'archivoConVinculo':
                    idPaginasWeb = [];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    reglasDeCampo.requerido = false;
                    break;
                case 'imagenesObligaciones':
                    idPaginasWeb = [];
                    idSecciones = [83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,167,168,169,170,171,172,173,174,204,205,206,207];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'catalogoPoderes':
                    idPaginasWeb = [];
                    idSecciones = [3];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                default:
            }
            return reglasDeCampo;
        },
        /**
         * Metodo encargado de buscar un id dentro de una lisa, en este caso saber si un campo
         * del formulario es requerido.
         * @see {@link asignarPrioridadACamposDeFormulario}
         * @param {Number} idAComparar [valor correspondiente a la pagina web o seccion seleccionada]
         * @param {Number} listaDeId [id de paginasWeb o secciones que son comunicados]
         * @returns {boolean} esRequerido [indica si el input es requerido(true) o no(false)]
         */
        compararListaDeId: function(idAComparar, listaDeId) {
            let esRequerido = false;
            listaDeId.forEach((id)=>{
                if(id == idAComparar){
                    esRequerido = true;
                }
            });
            return esRequerido;
        },
        /**
         * Metodo encargado para saber si el contenido es comunicado o no.
         * @see {@link asignarPrioridadACamposDeFormulario}
         * @param {Number} id [valor correspondiente a la pagina web]
         * @returns {boolean} esComunicado [indica si es comunicado(true) o no(false)]
         */
        paginaRequiereComunicado: function(id) {
            let comunicadosId = [19,20,21];
            let esComunicado = false;
            comunicadosId.forEach((comunicadoId)=>{
                if(comunicadoId == id){
                    esComunicado = true;
                }
            });
            return esComunicado;
        },

        /*
         * Método con para saber los campos requeridos parala seccion. no esta en uso aun
        */        
        obtenerCamposRequeridosSeccion: function(tipoFormato, idPagina){
         let camposParaElFormulario = [];
         switch(tipoFormato){
            case formatos.tipoDeFormulario.ListaDeVinculos:
                camposParaElFormulario = ['archivosDeContenido','fechaDePublicacion','disposicionEspecial']
                break;
            case formatos.tipoDeFormulario.CartasConVinculos:
                camposParaElFormulario = ['textoDelContenido','textoDelVinculo','archivosDeContenido','fechaDePublicacion']
                break;
            case formatos.tipoDeFormulario.TablaDeVinculos:
                if(idPagina ==19||idPagina ==20||idPagina ==21||idPagina ==41){
                    camposParaElFormulario = ['textoDelContenido','textoDelVinculo','archivosDeContenido','titulo','imagenDeContenido','opcionesComunicadoUrgente','fechaDePublicacion','disposicionEspecial',]
                }else{
                    camposParaElFormulario = ['textoDelContenido','textoDelVinculo','archivosDeContenido','fechaDePublicacion','disposicionEspecial']
                }                
                break;
            case formatos.tipoDeFormulario.VinculoConModal:
                camposParaElFormulario = ['','','']
                break;
            case formatos.tipoDeFormulario.TablaConTexto:
                camposParaElFormulario = ['textoDelContenido','fechaDePublicacion']
                break;
            /*case formatos.tipoDeFormulario.Transparencia:
                camposParaElFormulario = ['','','']
                break;
            case formatos.tipoDeFormulario.Embebido:
                camposParaElFormulario = ['','','']
                break;
            case formatos.tipoDeFormulario.TextoYBotonConVinculo:
                camposParaElFormulario = ['','','']
                break;*/
            case formatos.tipoDeFormulario.CarruselConContexto:
                camposParaElFormulario = ['imagenDeContenido','fechaDePublicacion','rangoPresidente','nombrePresidente',]
                break;
           /* case formatos.tipoDeFormulario.Mapa:
                camposParaElFormulario = ['','','']
                break;*/
            case formatos.tipoDeFormulario.SoloTexto:
                camposParaElFormulario = ['textoDelContenido','fechaDePublicacion']
                break;
            /*case formatos.tipoDeFormulario.TocasElectorales:
                camposParaElFormulario = ['','','']
                break;*/
         }
         return camposParaElFormulario;
        }

      },
      created(){
          this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",false);
          this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarPasoTres",false);
          this.$store.dispatch("A_SICPO_Catalogos_establecer007PaginasWeb",{llave: 'catalogoPaginaPasoUno',valor: -1});
      },
      computed:{
          obtenerCatalogoPaginasWeb() {
              return this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb;
          }
      }
  }
</script>
<style scoped>
.btn-primary{
    background-color: var(--verde-pj-100);
}
.btn-primary:hover{
    background-color: var(--verde-pj);
}
.area{
    color: #000000;
}

.tipoDePagina_DIV {
    display: flex;
    
}
#subidordearchivos_div {
    text-align: center
}
.vr {
    width:1px;
    background-color: white;
    margin-left: 15px;
}

.secciones {
    margin-top: 20px;
}

.subscciones {
    padding:0; 
    margin: 0;
    margin-top: 6px;
}
h5, h6{
        user-select: none;
}

.desabilitar-div-pasoUno {
    pointer-events: none;
    opacity: 0.4;
}

#pasoUno-aviso-secciones {
     padding: 1em;
     background-color: #26272b;
     border: 1px solid #5c5959;
     border-radius: 8px;
     margin-bottom: 1em;;
 }

</style>



// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/AltaDeContenido/CFormularioPasoUno.vue